"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Message_1 = __importDefault(require("../i18n/Message"));
var prop_types_1 = __importDefault(require("prop-types"));
var FormRowHorizontal = function (props) {
    var rowNameId = props.rowNameId, required = props.required, readOnly = props.readOnly, value = props.value, children = props.children;
    return (react_1.default.createElement("div", { className: "d-flex flex-row align-items-center aw-form-horizontal-field" },
        rowNameId && !readOnly && (react_1.default.createElement("div", { className: 'aw-form-horizontal-field-label' },
            react_1.default.createElement(Message_1.default, { messageId: rowNameId }))),
        react_1.default.createElement("div", { className: "d-flex flex-column" }, children)));
};
FormRowHorizontal.propTypes = {
    rowNameId: prop_types_1.default.string.isRequired,
    required: prop_types_1.default.bool,
};
exports.default = FormRowHorizontal;
//# sourceMappingURL=FormRowHorizontal.js.map